import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";

const ExecutionEntryCompleted = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry
        showCompleted
        showFiscalAssessmentsDocuments
      />
    </>
  );
}

export default ExecutionEntryCompleted;
